import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AttendanceAdminGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(): boolean {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    
    if (currentUser && currentUser.role === 'Attendance') {
      // Attendance users (Managers) can access the main dashboard, not the today's dashboard
      this.router.navigate(['/attendance']);
      return false;
    }
    
    return true;
  }
} 